import { render, staticRenderFns } from "./accountDetection.vue?vue&type=template&id=821224f8&scoped=true"
import script from "./accountDetection.vue?vue&type=script&lang=js"
export * from "./accountDetection.vue?vue&type=script&lang=js"
import style0 from "./accountDetection.vue?vue&type=style&index=0&id=821224f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821224f8",
  null
  
)

export default component.exports